import $ from 'jquery';
import PackAction from './PackAction.es6';
import Modaller from "./../modaller";

export default class PackShareAction extends PackAction {
    constructor(opts) {
        super(opts);
    }

    getTitleKey() {
        return 'packPage.dialogs.share.title';
    }

    _showModal(modal) {
        modal.setTitle(this.l18n.get(this.getTitleKey()));
        modal.centerFooterButtons();
        modal.addFooterButton(this.l18n.get('button.cancel'), "btn btn-secondary btn-cancel", function () {
            modal.close();
        });

        modal.addShowListener(() => {
            modal.content.find('input[name=shareLink]')
                .focus()
                .select();
        });
        this._onModalShown();
    }

    execute() {
        Modaller.showRemote(`${Flashcards.root}/set/${this.opts.packId}/share.ajax`
            , $.proxy(this._showModal, this));
    }
}